// extracted by mini-css-extract-plugin
module.exports = {"top":"BlogsTable_top__14lp3","rightSide":"BlogsTable_rightSide__2t6t0"};